import { render, staticRenderFns } from "./c_input_number.vue?vue&type=template&id=72e206f6&scoped=true"
import script from "./c_input_number.vue?vue&type=script&lang=js"
export * from "./c_input_number.vue?vue&type=script&lang=js"
import style0 from "./c_input_number.vue?vue&type=style&index=0&id=72e206f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e206f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72e206f6')) {
      api.createRecord('72e206f6', component.options)
    } else {
      api.reload('72e206f6', component.options)
    }
    module.hot.accept("./c_input_number.vue?vue&type=template&id=72e206f6&scoped=true", function () {
      api.rerender('72e206f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_input_number.vue"
export default component.exports